<template>
  <div>
    <div class="row-tb-head" style="margin-top: 10px">
      <span>费用信息</span>
      <div style="float: right" v-if="!IsDetail">
        <el-button type="primary" icon="el-icon-plus" @click="addRow"
          >添加</el-button
        >
      </div>
    </div>
    <el-table border class="table-line tb-c-head" :data="Data">
      <el-table-column type="index" label="序号" width="50" align="center"  />
      <el-table-column prop="CostName" label="费用名称" min-width="110"  align="center" >
        <template slot-scope="{ row }">
          <span v-if="IsDetail">{{ row.CostName }}</span>
          <cost-select
            v-else
            v-model="row.CostName"
            :source="DCost"
            @select="onSelect($event, row)"
          />
        </template>
      </el-table-column>
      <el-table-column prop="CostNo" label="费用编号" min-width="110"  align="center" />
      <el-table-column prop="ItemName" label="费用项目" min-width="110"  align="center" />

      <el-table-column prop="Amount" label="金额"  align="center" v-if="canPrice">
        <template slot-scope="{ row }">
          <span v-if="IsDetail">{{ row.Amount.toLocaleString() }}</span>
          <el-input
            v-else
            @input="onInput(row, 'Amount')"
            v-model="row.Amount"
            @blur="onBlur(row)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="TaxRate" label="税率(%)"  v-if="invoiceStatus && canPrice" align="center">
        <template slot-scope="{ row }">
          <span v-if="IsDetail">{{ row.TaxRate }}</span>
          <el-input
            v-else
            type="number"
            @input="onInput(row, 'TaxRate')"
            v-model="row.TaxRate"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="TaxAmount" label="税额" align="center" v-if="canPrice"/>
      <el-table-column prop="IncTaxAmount" label="含税金额" align="center" v-if="canPrice">
          <template slot-scope="{row}">
            {{row.IncTaxAmount.toLocaleString()}}
          </template>
      </el-table-column>
      <!-- <el-table-column prop="WriteoffAmount" label="累计结款金额" min-width="110px">
        <template slot-scope="{row}">
          <span v-if="IsDetail">{{row.WriteoffAmount}}</span>
          <el-input v-else @input="onInput(row,'WriteoffAmount')" v-model="row.WriteoffAmount"></el-input>
        </template>
      </el-table-column> -->
      <!-- <el-table-column prop="isA" label="是否计为销项税额" min-width="130px"  align="center"  >
        <template slot-scope="{row}">
          <el-select v-model="row.isA">
            <el-option :value="0" label="否" > </el-option>
            <el-option :value="1" label="是" > </el-option>
          </el-select>
        </template>
      </el-table-column> -->
      <el-table-column prop="Remark" label="备注" width="200px"  align="center" >
        <template slot-scope="{ row }">
          <span v-if="IsDetail">{{ row.Remark }}</span>
          <el-input
            v-else
            type="textarea"
            autosize
            @input="onInput(row)"
            v-model="row.Remark"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="95"
        fixed="right"
        v-if="!IsDetail"
      >
        <template slot-scope="{ row, $index }">
          <el-link
            style="margin-right: 10px"
            @click="copyRow(row, $index)"
            :underline="false"
            >复制</el-link
          >
          <el-link @click="delRow(row, $index)" :underline="false"
            >删除</el-link
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import costSelect from "@/components/basedata/finance/expenses/select";

export default {
  components: { costSelect },
  props: {
    IsDetail: {
      type: Boolean,
      default: false,
    },
    invoiceStatus: {
      type: Boolean,
      default: true,
    },
    canPrice: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      Data: [],
      DelData: [],
      DCost: [],
      DefTaxRate: null,
      isMB: this.$store.state.isMB,
    };
  },
  methods: {
    setCost(data, DefTaxRate=0) {
      this.DCost = data;
      this.DefTaxRate = DefTaxRate;
    },
    setData(data) {
      this.Data = data;
    },
    getData() {
      var data = this.Data.filter((x) => x.T != null);
      this.DelData.forEach((x) => data.push(x));
      return data;
    },
    addRow() {
      this.Data.push({
        DocDtsId: 0,
        DocId: 0,
        CostId: 0, //费用
        CostNo: "",
        CostName: "",
        Amount: null, //金额
        TaxRate: this.DefTaxRate, //税率
        TaxAmount: null, //税额
        IncTaxAmount: null, //含税金额
        // NoTaxAmount: null, //无税金额
        WriteoffAmount: null, //累计结款金额
        isA:0,
        Remark: "",
        T: 0,
      });
    },
    onInput(row, type) {
      row.T = row.T == 0 ? 0 : 1;
      if (type) {
        if(type=="Amount"){
          
        }else{          
        row[type] = this.$commonJs.obj.toNumber(row[type]);
        }
        if (row.Amount && row.TaxRate) {
          //税额 = 金额 * 税率
          row.TaxAmount = (row.Amount * (row.TaxRate / 100)).toFixed(2);
        } else row.TaxAmount = null;

        if (row.Amount && row.TaxAmount) {
          //含税金额 = 金额 + 税额
          row.IncTaxAmount = (
            parseFloat(row.Amount) + Number(row.TaxAmount)
          ).toFixed(2);
        } else row.IncTaxAmount = row.Amount;
      }
    },    
    onBlur(row){
      if(isNaN(row.Amount)){
        row.Amount=0
      }
      if(isNaN(row.IncTaxAmount)){
        row.IncTaxAmount=0
      }
    },
    onSelect(e, row, type) {
      row.T = row.T == 0 ? 0 : 1;
      row.CostId = e.CostId;
      row.CostNo = e.CostNo;
      row.CostName = e.CostName;
      row.ItemName = e.ItemName;
      if (e.TaxRate) row.TaxRate = e.TaxRate;
    },
    delRow(row, index) {
      if (row.T != 0) this.DelData.push({ ...row, T: 2 });
      this.Data.splice(index, 1);
    },
    copyRow(row) {
      this.Data.push({ ...row, T: 0,CostId:0 });
    },
    clear() {
      this.Data = [];
      this.DelData = [];
      this.DCost = [];
    },
  },
};
</script>